/* eslint-disable @typescript-eslint/no-explicit-any */
import { hasRestrictedCategoriesValidation } from '@/components/RestrictedAge/useCases/categoriesValidation'
import { useRestrictedAgeContext } from '@/context/RestrictedAgeContext'
import { useHeaderDataConfig } from '@/hooks/useHeaderDataConfig'
import { isArray } from '@apollo/client/utilities'
import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'
import { sendScreenViewEventSSR } from '@mercadoni/sinister/dist/cjs/monitors'
import { useEffect } from 'react'

const CategoryLogic = ({
  Wrapper,
  clientModel,
  onRouterChange,
  isMobile,
}: any) => {
  const {
    category = {},
    error = false,
    store,
    pagination,
    banners: categoryBanners,
    promoted,
    carousels,
  } = useFiltersContext()
  const { clientId } = clientModel
  const { version, screenNames } = useHeaderDataConfig(clientModel)
  const { openRestrictedAge, getStoredRestrictedAge } =
    useRestrictedAgeContext()

  useEffect(() => {
    if (!category?.name) return
    sendScreenViewEventSSR({
      clientId,
      store,
      version,
      screenName: screenNames['/ca']?.getScreenName?.(category) ?? '',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category?.name])

  useEffect(() => {
    const hasRestricted = hasRestrictedCategoriesValidation({ category })
    if (hasRestricted && getStoredRestrictedAge() !== true) {
      openRestrictedAge()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category.products])

  return (
    <Wrapper
      clientModel={clientModel}
      loading={false}
      error={error}
      category={isArray(category) ? {} : category}
      productsLength={pagination?.total?.value || 0}
      categoryBanners={categoryBanners}
      promoted={promoted}
      onRouterChange={onRouterChange}
      carousels={carousels}
      isMobile={isMobile}
    />
  )
}

export default CategoryLogic
